import { i18n, type MessageDescriptor } from '@lingui/core';
import { msg, t } from '@lingui/core/macro';

import { can, defineScreen } from '@/shared/screen/define';
import type { ScreenContext } from '@/shared/screen/types';

// Manifesto do Desconto (U23, U42). Arquivo leve: entra no `src/app/screens.ts` e no ⌘K. A rota só existe com
// `DESCONTO_MENU === 1` (router.tsx:1233) e herda `CreditNote:Read` de `/ccb` (router.tsx:995-1001).

export const DISCOUNT_PATH = '/ccb/desconto';

export const DISCOUNT_READ = can('CreditNote', 'Read');

/**
 * Sem ferramenta do agente: a remessa CNAB é um arquivo que só a pessoa escolhe, e abrir a operação depende do
 * tomador, do produto, do cessionário e da conta que ela seleciona. O agente só lê o estado (contexto).
 */
export const discountScreen = defineScreen({
  id: 'discount.form',
  path: DISCOUNT_PATH,
  title: msg`Desconto`,
  description: msg`Desconto de títulos a partir de um arquivo de remessa CNAB 600: a pessoa escolhe o arquivo, confere os títulos descontados e o plano de pagamento e abre a operação de crédito. O agente só lê esta tela.`,
  permission: DISCOUNT_READ,
  access: { flag: { key: 'DESCONTO_MENU', equals: 1 } },
  place: { icon: 'receipt-text', section: 'credit-note' },
  actions: [],
});

/** O título de cada passo (`discount.flow.ts`), aqui para o manifesto seguir leve. */
const STEP_TITLES: Readonly<Record<string, MessageDescriptor>> = {
  arquivo: msg`Arquivo`,
  dados: msg`Dados do desconto`,
  operacao: msg`Abrir operação`,
};

/** O que o agente lê da tela (U24, U46 D2-C): no idioma da tela, o passo e o tamanho da remessa, sem nome nem documento. */
export function discountContext(input: { readonly step: string; readonly titles: number | undefined; readonly productChosen: boolean }): ScreenContext {
  const title = STEP_TITLES[input.step];
  const step = title ? i18n._(title) : input.step;
  const titles = input.titles;
  return {
    summary: [
      t`Desconto, passo ${step}.`,
      titles === undefined ? t`Nenhum arquivo de remessa carregado ainda.` : t`Remessa carregada com ${titles} títulos.`,
      input.productChosen ? t`Produto de desconto escolhido.` : '',
    ]
      .filter(Boolean)
      .join(' '),
    fields: { step: input.step, titles: input.titles ?? null },
    sensitivity: 'internal',
  };
}
